import React, { useMemo } from 'react';
import { Box, ExpressSetupDangerIcon, ExpressSetupDoneIcon, Hint, Inscription } from '@common-fe/common-fe';

import { Copay } from '@/modules/ExpressSetup/ExpressSetup.types.ts';

import { RenewalSetupStep, RenewalSetupStepTitle } from '../../RenewalSetup.types';
import { ProgressBarTitle } from '../../styles/RenewalSetup.styles';

interface Props {
  stepName: RenewalSetupStep;
  title: RenewalSetupStepTitle;
  copays?: Copay[];
  isEntityExist?: boolean;
  isFailed?: boolean;
  isLastItem?: boolean;
  isActive?: boolean;
  isDisabled?: boolean;
  isValidating?: boolean;
  handleStepName: (stepName: RenewalSetupStep) => void;
}

const ProgressBarItem: React.FC<Props> = ({
  stepName,
  title,
  copays,
  isEntityExist,
  isFailed,
  isLastItem,
  isActive,
  isDisabled,
  isValidating,
  handleStepName,
}) => {
  const titleColor = useMemo(() => {
    if (isFailed) return 'danger';
    if (isEntityExist) return isDisabled ? 'successBorder' : 'success';
    return isDisabled ? 'textDisabled' : 'textBody';
  }, [isDisabled, isEntityExist, isFailed]);

  const progressTitleElement = useMemo(
    () => (
      <Box
        style={{
          cursor: isDisabled ? 'not-allowed' : 'pointer',
        }}
      >
        <ProgressBarTitle
          onClick={() => handleStepName(stepName)}
          color={titleColor}
          style={{ pointerEvents: isDisabled ? 'none' : 'auto' }}
          size="16px"
          weight={isActive ? 700 : 400}
        >
          {title}
        </ProgressBarTitle>
      </Box>
    ),
    [isDisabled, handleStepName, titleColor, isActive, title, stepName]
  );
  return (
    <Box data-testid="renewal-setup-progerss-bar-item" direction="row">
      {isFailed ? (
        <ExpressSetupDangerIcon
          size="24px"
          color={isDisabled ? 'dangerBorder' : 'danger'}
          data-testid="progress-bar-item-failed-icon"
        />
      ) : isEntityExist ? (
        <ExpressSetupDoneIcon size="24px" color={isDisabled ? 'successBorder' : 'success'} />
      ) : (
        <Box
          round="50%"
          background="background3"
          style={{ opacity: isDisabled ? 0.05 : 0.1 }}
          height="24px"
          width="24px"
        />
      )}
      {isDisabled ? (
        <Hint hintAlign="right" hintElement={progressTitleElement}>
          <Inscription size="small">
            {isValidating
              ? 'Validating plan codes, please wait…'
              : 'You need to finish the previous configuration to continue.'}
          </Inscription>
        </Hint>
      ) : (
        progressTitleElement
      )}
    </Box>
  );
};

export default ProgressBarItem;
